import LinkContainer from './LinkContainer';
import LinkRow from './LinkRow';

function NewsContents() {
  return (
        <LinkContainer title='새소식'>
            <LinkRow label='이벤트' activityName='BoardActivity'
                     activityParams={{ type: 'EVENT' }}/>
            <LinkRow label='공지사항'
                     activityParams={{ type: 'NOTICE' }}
                     activityName='BoardActivity'/>
        </LinkContainer>
  );
}

export default NewsContents;
